import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserService } from "../services/user.service";
import { ProductRequest as ProductRequestType } from "../models/product.models";
import ProductsTable from "../components/client-dashboard/product-request-table/ProductRequestTable";
import { PaginationModel } from "../components/common/CustomTable";
import { GridSortModel } from "@mui/x-data-grid";

const BlockchainStatusPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [requests, setRequests] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [tablePage, setTablePage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const limit = 7;

  const fetchRequests = async () => {
    setIsLoading(true);
    const res: ProductRequestType | undefined =
      await UserService.getUserProductRequests(
        currentPage,
        limit,
        "Blockchain Analysis"
      );
    const data = res?.data || [];

    setTotalPages(res?.total || 0);

    setRequests(data);
    if (data.length === 0) {
      navigate("/blockchain-analysis/new", { replace: true });
    }
    setIsLoading(false);
  };
  const navigate = useNavigate();

  const onPagination = ({ page }: PaginationModel) => {
    setCurrentPage(page + 1);
    setTablePage(page);
  };

  useEffect(() => {
    if (requests.length) {
      fetchRequests();
    }
  }, [currentPage]);

  useEffect(() => {
    fetchRequests();
  }, [navigate]);

  const onSortColumn = async (model: GridSortModel) => {
    if (model[0].field === "productName") {
      return;
    }
    setIsLoading(true);
    try {
      const requests = await UserService.getUserProductRequests(
        currentPage,
        7,
        "Blockchain Analysis",
        null,
        null,
        model
      );
      if (requests?.data) {
        setRequests(requests.data);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ position: "relative" }}>
      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", left: "45%", top: "50%", zIndex: "1000" }}
        />
      )}
      <Box
        sx={{
          padding: "24px",
          background: "white",
          minHeight: "60vh",
          opacity: isLoading ? "0.3" : "1",
          pointerEvents: isLoading ? "none" : "all",
        }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          Blockchain Analysis Request Status
        </Typography>
        <ProductsTable
          onSortColumn={onSortColumn}
          requests={{
            data: requests,
            total: totalPages,
            page: tablePage,
            totalPages: 1,
          }}
          page={tablePage}
          onPagination={onPagination}
          onRowClick={(params) =>
            navigate(`/blockchain-analysis/status/${params.row.id}`)
          }
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/blockchain-analysis/new")}
          sx={{ mt: 2 }}
        >
          Submit New Request
        </Button>
      </Box>
    </Box>
  );
};

export default BlockchainStatusPage;
